import { Upload, UploadDTO } from '@/controllers/Uploads';
import { GlobalActionTypes } from '@/store/reducers/global/action-types';
import { BucketFileVm, ReduxAction, ReduxActionChain } from '@/types';

import { UploadsQueueActionTypes } from './action-types';
import { UploadStatus } from './types';

export const initialiseUploadingQueue = (): ReduxAction => ({
  type: UploadsQueueActionTypes.INITIALIZE_UPLOADING_QUEUE,
});

export const addUploadsToUploadingQueue = (uploads: Upload[] | UploadDTO[]): ReduxAction => ({
  type: UploadsQueueActionTypes.ADD_UPLOADS_TO_THE_UPLOADING_QUEUE,
  payload: uploads,
});

export const startUploading = (): ReduxAction => ({
  type: UploadsQueueActionTypes.START_UPLOADING,
});

export const startUpload = (): ReduxAction => ({
  type: UploadsQueueActionTypes.START_UPLOAD.START,
});

export const cancelAllUploads = (): ReduxAction => ({
  type: UploadsQueueActionTypes.CANCEL_ALL_UPLOADS,
});

export const cancelUpload = (id: string): ReduxAction => ({
  type: UploadsQueueActionTypes.CANCEL_UPLOAD,
  payload: id,
});

export const removeUploadsFromUploadingQueueByBucketId = (bucketId: string): ReduxAction => ({
  type: UploadsQueueActionTypes.REMOVE_FROM_UPLOADING_QUEUE_BY_BUCKET_ID,
  payload: bucketId,
});

export const updateUploadsBucketName = (bucketId: string): ReduxActionChain => ({
  type: GlobalActionTypes.ACTION_CHAIN,
  actions: [
    { type: UploadsQueueActionTypes.UPDATE_UPLOADS_BUCKET_NAME, payload: { bucketId } },
    startUploading(),
  ],
});

export const changeUploadStatusToInProgress = (id: string): ReduxAction => ({
  type: UploadsQueueActionTypes.CHANGE_UPLOAD_STATUS_TO_IN_PROGRESS,
  payload: { id, uploadStatus: UploadStatus.InProgress },
});

export const changeUploadStatusToSucceed = (id: string): ReduxAction => ({
  type: UploadsQueueActionTypes.CHANGE_UPLOAD_STATUS_TO_SUCCEED,
  payload: { id, uploadStatus: UploadStatus.Succeed },
});

export const changeUploadStatusToCanceled = (id: string): ReduxAction => ({
  type: UploadsQueueActionTypes.CHANGE_UPLOAD_STATUS_TO_CANCELED,
  payload: { id, uploadStatus: UploadStatus.Canceled },
});

export const changeUploadStatusToFailed = (id: string, error?: string): ReduxAction => ({
  type: UploadsQueueActionTypes.CHANGE_UPLOAD_STATUS_TO_FAILED,
  payload: {
    id,
    uploadStatus: UploadStatus.Failed,
    error,
  },
});

export const fetchAttachmentsList = (bucketId: string): ReduxAction => ({
  type: UploadsQueueActionTypes.FETCH_ATTACHMENTS_LIST.START,
  payload: { bucketId },
});

export const clearAttachmentsList = (): ReduxAction => ({
  type: UploadsQueueActionTypes.CLEAR_ATTACHMENTS_LIST,
});

export const deleteAttachment = (
  bucketId: string,
  uploadDTO: BucketFileVm,
  activityId?: string,
): ReduxAction => ({
  type: UploadsQueueActionTypes.DELETE_ATTACHMENT.START,
  payload: {
    activityId,
    bucketId,
    uploadDTO,
  },
});
